import { RouteObject } from 'react-router';
import { PROTECTED_ROUTES } from '@/constants/route.constant';

export const timesheetRoutes:RouteObject[] = [
  {
    path: PROTECTED_ROUTES.DASHBOARD.TIMESHEET,
    lazy: {
      Component: async () => (await import('./components')).default,
    },
  },
];

